export default __webpack_public_path__ + "static/media/title.7d4cdc65.svg";